import { isEmpty } from 'lodash-es';
import { createSelector } from 'reselect';
import { RootState } from 'store';

export const selectAppIsReady = createSelector(
  [
    (state: RootState) => state.user,
    (state: RootState) => state.app,
    (state: RootState) => state.filters,
    (state: RootState) => state.configuration,
    (state: RootState) => state.permissions,
    (state: RootState) => state.layoutConfiguration,
  ],
  (user, app, filters, configuration, permissions, layoutConfiguration) => {
    const statesLoaded = [user, app, filters, configuration].every(
      (state) => state !== null
    );
    const permissionsValid = !isEmpty(permissions);
    const layoutConfigsDefined = [
      layoutConfiguration.isMenuExpanded,
      layoutConfiguration.menuVersion,
      layoutConfiguration.isNewMenuNotified,
    ].every((config) => config !== undefined);

    return statesLoaded && permissionsValid && layoutConfigsDefined;
  }
);
